import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles/App.css';
import './assets/styles/admin.css';

// Firebase initialization
import './services/firebase/config';
// Import settingsService to ensure it's initialized
import { initializeSettings } from './services/firebase/settingsService';

// Routes
import ClientRoutes from './client/routes';
import AdminRoutes from './admin/routes';

// Layouts
import ClientLayout from './client/layouts/ClientLayout';
import AdminLayout from './admin/layouts/AdminLayout';

// Utilities
import ScrollToTop from './components/common/ScrollToTop';



function App() {
  useEffect(() => {
    // Initialize Firebase settings when the app starts
    const initializeApp = async () => {
      try {
        await initializeSettings();
      } catch (error) {
        console.error('App.js: Error initializing settings:', error);
      }
    };
    
    initializeApp();
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          {/* Client Routes Wrapper */}
          <Route element={<ClientLayout />}>
            {ClientRoutes}
          </Route>

          {/* Admin Routes Wrapper */}
          <Route element={<AdminLayout />}>
            {AdminRoutes}
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;